<div class="popup">
	<div class="popup-header">
		<div class="popup-title">{{ 'SHIFT_TEMPLATES.TEMPLATES' | translate }}</div>
	</div>
	<div class="popup-body">
		<qo-radio-list
			[options]="options"
			[(selectedOption)]="selectedOption"
		>
		</qo-radio-list>
	</div>

	<div class="popup-footer">
		<button class="qo-button-standard qo-no" (click)="removeShiftTemplate()">{{ 'GLOBAL.DELETE' | translate }}</button>
		<button class="qo-button-standard qo-grey" (click)="close()">{{ 'GLOBAL.CLOSE' | translate }}</button>
		<button class="qo-button-standard qo-primary" (click)="insertTemplate()">{{ 'GLOBAL.INSERT' | translate }}</button>
	</div>
</div>
